"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addData = addData;
exports.delData = delData;
exports.exportData = exportData;
exports.findAllDict = findAllDict;
exports.getData = getData;
exports.getDicts = getDicts;
exports.listData = listData;
exports.updateData = updateData;
var _request = _interopRequireDefault(require("@/utils/request"));
var _cloud = require("@/utils/cloud");
// 查询字典数据列表
function listData(query) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/dict/data/list',
    method: 'get',
    params: query
  });
}

// 查询字典数据详细
function getData(dictCode) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/dict/data/' + dictCode,
    method: 'get'
  });
}

// 根据字典类型查询字典数据信息
function getDicts(dictType) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/dict/data/type/' + dictType,
    method: 'get'
  });
}

// 新增字典数据
function addData(data) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/dict/data',
    method: 'post',
    data: data
  });
}

// 修改字典数据
function updateData(data) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/dict/data',
    method: 'put',
    data: data
  });
}

// 删除字典数据
function delData(dictCode) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/dict/data/' + dictCode,
    method: 'delete'
  });
}

// 导出字典数据
function exportData(query) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/dict/data/export',
    method: 'get',
    params: query
  });
}

// 查询系统所有字典（缓存处理）
function findAllDict() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/dict/data/findAllDict',
    method: 'get'
  });
}